import { resolveEndpoint } from '../endpointUtils';

export default {
	getCustomerCapabilities: {
		uri: '/ibapi/v2/banks/:bankId/customers/:customerId/capabilities',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(bankId, customerId) {
			return resolveEndpoint(this.uri, { bankId, customerId });
		},
	},
};
